import { Action, createReducer, on } from '@ngrx/store';
import * as vendorAdminActions from 'src/app/compliance/store/actions/vendor-admin.actions';
import { VendorAdminState } from '../state/vendor-admin.state';

const initialState: VendorAdminState = {
    fetchArgs: null,
    vendorAdminRecords: null
};

const reducer = createReducer(
    initialState,
    on(vendorAdminActions.setVendorFetchArgs, (state, action) => ({
        ...state,
        fetchArgs: action.fetchArgs
    })),
    on(vendorAdminActions.getListOfVendorAdminRecordsSuccess, (state, action) => ({
        ...state,
        vendorAdminRecords: action.vendorAdminRecords,
        error: null
    })),
    on(vendorAdminActions.getListOfVendorAdminRecordsFailure, (state, action) => ({
        ...state,
        error: JSON.stringify(action.error)
    }))
);

export function vendorAdminReducer(state: VendorAdminState | undefined, action: Action) {
    return reducer(state, action);
}
